<script>
import "./vfigma.button.scss";
import FButtonButton from "./FButtonButton.vue";
import FButtonLink from "./FButtonLink.vue";
export default {
  functional: true,
  // props: {
  //   click: Function,
  //   label: String,
  //   pending: Boolean,
  //   type: [Array, String],
  //   href: String,
  //   blank: Boolean,
  // },
  render: function (createElement, context) {
    // Transparently pass any attributes, event listeners, children, etc.
    if (context?.data?.attrs?.href) {
      return createElement(FButtonLink, context.data, context.children);
    }
    return createElement(FButtonButton, context.data, context.children);
  },
};
</script>
